import { FilterGroup } from '@features/ui-filters/components/types';

export type SortOrder = 'ASC' | 'DESC';

export type PaginatedOptions = {
  filters?: FilterGroup;
  page?: number;
  pageSize?: number;
  sort?: { field: string; order: SortOrder };
};

export interface PaginatedResponse<T> {
  items: T[];
  pages: number;
  total: number;
}

export type AccessPermissions = {
  canEdit: boolean;
  canDelete: boolean;
};

export const ACTIONS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  ADD: 'ADD',
  DELETE: 'DELETE',
} as const;

export type Action = (typeof ACTIONS)[keyof typeof ACTIONS];

export type ActionMessages<T> = {
  [key in Action]?: {
    successTitleKey?: string;
    successDescriptionKey?: string;
    errorTitleKey?: string;
    errorDescriptionKey?: string;
    formatMessage: (data: T) => Record<string, string>;
  };
};
